import React from 'react';
import './Section2.css';
import { FaCode, FaServer, FaPalette, FaBrain, FaReact, FaHtml5, FaCss3Alt, FaPython } from 'react-icons/fa';
import { SiJavascript, SiFlask, SiFastapi, SiMongodb, SiMysql, SiFigma, SiMui, SiCanva, SiTensorflow, SiScikitlearn, SiOpencv, SiBlender, SiPostman, SiHuggingface } from 'react-icons/si';

export function Section2() {
  const roles = [
    {
      title: "Frontend Development",
      icon: <FaCode className="role-icon" />,
      techStack: [
        { icon: <FaReact />, name: "React.js" },
        { icon: <SiJavascript />, name: "JavaScript" },
        { icon: <FaHtml5 />, name: "HTML" },
        { icon: <FaCss3Alt />, name: "CSS" },
        {icon: <SiPostman />, name: "Postman" }
      ],
      points: [
        "Building responsive and interactive user interfaces",
        "Creating seamless user experiences with modern frameworks",
        "Implementing progressive web applications"
      ]
    },
    {
      title: "Backend Development",
      icon: <FaServer className="role-icon" />,
      techStack: [
        { icon: <FaPython />, name: "Python" },
        { icon: <SiFlask />, name: "Flask" },
        { icon: <SiFastapi />, name: "FastAPI" },
        { icon: <SiMongodb />, name: "MongoDB" },
        { icon: <SiMysql />, name: "SQL" }
      ],
      points: [
        "Designing scalable server architectures",
        "Implementing secure API endpoints",
        "Database design and optimization"
      ]
    },
    {
      title: "UI/UX Design",
      icon: <FaPalette className="role-icon" />,
      techStack: [
        { icon: <SiFigma />, name: "Figma" },
        { icon: <SiMui />, name: "Material UI" },
        { icon: <SiBlender />, name: "SiBlender" },
        { icon: <SiCanva />, name: "SiCanva" }
      ],
      points: [
        "Creating intuitive user interfaces",
        "Designing responsive layouts",
        "Implementing modern design principles"
      ]
    },
    {
      title: "Machine Learning",
      icon: <FaBrain className="role-icon" />,
      techStack: [
        { icon: <SiTensorflow />, name: "TensorFlow" },
        { icon: <SiScikitlearn />, name: "Scikit-learn" },
        { icon: <SiHuggingface />, name: "SiHuggingface" },
        { icon: <SiOpencv />, name: "OpenCV" }
      ],
      points: [
        "Developing ML models for real-world applications",
        "Implementing computer vision solutions",
        "Data analysis and visualization"
      ]
    }
  ];

  return (
    <div className="section2-container">
      <h2 className="section-title">What I Do</h2>
      <div className="roles-container">
        {roles.map((role, index) => (
          <div className={`role-card ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
            <div className="role-icon-container">{role.icon}</div>
            <div className="role-info">
              <h3 className="role-title">{role.title}</h3>
              <div className="tech-stack">
                {role.techStack.map((tech, idx) => (
                  <span key={idx} className="tech-item" title={tech.name}>
                    {tech.icon}
                  </span>
                ))}
              </div>
              <ul className="role-points">
                {role.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Section2;
